import { useTranslation } from "react-i18next";

const milestones = [
  { year: "2026", status: "done", titleKey: "rm1_title", detailKey: "rm1_detail", icon: "ri-checkbox-circle-fill" },
  { year: "2027", status: "active", titleKey: "rm2_title", detailKey: "rm2_detail", icon: "ri-loader-4-line" },
  { year: "2028", status: "upcoming", titleKey: "rm3_title", detailKey: "rm3_detail", icon: "ri-building-4-line" },
  { year: "2030+", status: "upcoming", titleKey: "rm4_title", detailKey: "rm4_detail", icon: "ri-sun-line" },
];

const statusStyle = {
  done: { dot: "bg-emerald-400", text: "text-emerald-400", badge: "bg-emerald-400/10 border-emerald-400/30 text-emerald-400" },
  active: { dot: "bg-amber-400 animate-pulse", text: "text-amber-400", badge: "bg-amber-400/10 border-amber-400/30 text-amber-400" },
  upcoming: { dot: "bg-white/20", text: "text-white/30", badge: "bg-white/5 border-white/10 text-white/30" },
};

export default function RoadmapSection() {
  const { t } = useTranslation();

  return (
    <section id="roadmap" className="relative py-16 md:py-32 bg-[#050810]">
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "radial-gradient(circle at 50% 100%, rgba(255,180,0,0.3) 0%, transparent 50%)" }} />
      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-12">
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-6 md:w-8 h-px bg-amber-400/60" />
            <span className="text-amber-400 text-[10px] md:text-xs tracking-[0.3em] uppercase" style={{ fontFamily: "'Orbitron', sans-serif" }}>{t("roadmap_badge")}</span>
            <div className="w-6 md:w-8 h-px bg-amber-400/60" />
          </div>
          <h2 className="text-2xl md:text-5xl font-black text-white mb-3 md:mb-4" style={{ fontFamily: "'Orbitron', sans-serif" }}>{t("roadmap_title")}</h2>
          <p className="text-white/40 text-xs md:text-sm max-w-xl mx-auto">{t("roadmap_subtitle")}</p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-white/10 md:-translate-x-1/2" />
          <div className="space-y-8 md:space-y-12">
            {milestones.map((m, i) => {
              const s = statusStyle[m.status as keyof typeof statusStyle];
              const isRight = i % 2 === 0;
              return (
                <div key={m.year} className={`relative flex flex-col md:flex-row ${isRight ? "md:flex-row" : "md:flex-row-reverse"} items-start md:items-center gap-4 md:gap-0`}>
                  <div className={`w-full md:w-[calc(50%-2rem)] ${isRight ? "md:pr-8 md:text-right" : "md:pl-8"} pl-10 md:pl-0`}>
                    <div className={`inline-block px-2 md:px-3 py-0.5 md:py-1 rounded-full text-[10px] md:text-xs border mb-2 md:mb-3 ${s.badge}`} style={{ fontFamily: "'Orbitron', sans-serif" }}>{m.year}</div>
                    <h3 className="text-white font-bold text-sm md:text-base mb-1 md:mb-2" style={{ fontFamily: "'Orbitron', sans-serif" }}>{t(m.titleKey)}</h3>
                    <p className="text-white/40 text-xs md:text-sm leading-relaxed">{t(m.detailKey)}</p>
                  </div>
                  <div className="absolute left-4 md:left-1/2 md:-translate-x-1/2 flex flex-col items-center z-10">
                    <div className={`w-3 h-3 md:w-4 md:h-4 rounded-full border-2 border-[#050810] ${s.dot}`} />
                  </div>
                  <div className="hidden md:block w-[calc(50%-2rem)]" />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
